import React from 'react';
import { NavLink } from 'react-router-dom';

import { Scopes } from "Services";

export default ({ scope, ...props }) => {
    const className = `font-medium focus:outline-none focus:underline transition
     ease-in-out duration-200 text-app-blue-dark hover:text-app-blue-light ${ props.className }`;

    if (scope !== undefined && Scopes.has(scope) === false) {
        return (
            <div>
                { props.label || props.children }
            </div>
        );
    }

    if (props.onClick !== undefined) {
        return (
            <button
                type="button"
                onClick={ props.onClick }
                className={ className }>
                { props.label ?? props.children }
            </button>
        );
    }

    if (props.to !== undefined) {
        return (
            <NavLink
                to={props.to}
                target={props.target}
                className={className}>
                {props.label ?? props.children}
            </NavLink>
        );
    }

    if (props.email !== undefined) {
        return (
            <a href={ `mailto:${ props.email }` } className={ className }>
                { props.label ?? props.children }
            </a>
        );
    }

    return null;
};
